export const defaultCircleStyles = {
    fill: {
      color: 'white',
    },
    stroke: {
      color: '#505050',
      width: 1.7
    },
    radius: 12
  }
  export const defaultTextStyles = (title) => ({
    text: title,
    offsetY: 26,
    font: {
      size: '17',
    },
    stroke: {
      width: 0.1
    },
    background: {
      fill: {
        color: 'white'
      },
      stroke: {
        width: 1,
        color: '#000000'
      },
    },
    padding: [1,5,1,5]
  });

  export const defaultImageStyles = (canvas, img, src) => ({
    crossOrigin: 'anonymous',
    img: canvas,
    imgSize: canvas && img ? [img.width, img.height] : undefined,
    src
  })